import { PROFILE_HEADER, BOTTOM_SHEET_IFRAME } from './component-types';
import { ProfileHeader, BottomSheetIframe, withBottomSheetContext } from 'eshops-components-library';

const Resources = {};
Resources[PROFILE_HEADER] = withBottomSheetContext(ProfileHeader);
Resources[BOTTOM_SHEET_IFRAME] = withBottomSheetContext(BottomSheetIframe);

export default Resources;
